import {Form as AntForm} from 'antd';
import React, {useEffect} from 'react';

import Form from '../../../../../components/Form/Form';
import MobileModalForm from '../../../../../components/Form/MobileModalForm';
import * as formInputNames from '../../../../../consts/form/formInputNames';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import useIsMobileViewport from '../../../../../hooks/useIsMobileViewport';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';
import log from '../../../../../services/logger/log';
import organizationsService from '../../../../../services/organizations/organizationsService';
import helpers from '../../../../../utils/helpers';
import arsBuildingModalService from './arsBuildingsModalService';

const ArsBuildingsModal = (props) => {
    const {onOk, onCancel, selectedBuilding, selectedAddresses = []} = props;
    const [form] = AntForm.useForm();
    const isMobile = useIsMobileViewport();
    const strings = getLocalizedStrings();

    const modalData = arsBuildingModalService.getAddArsBuildingsModalContent({selectedBuilding});

    const {formContent, title, submitButton, cancelButton, initialValues, requireDeps} = modalData || {};

    const onFinish = async () => {
        try {
            const values = await form.validateFields();

            const formValues = {...initialValues, ...values};

            helpers.runFunction(onOk, formValues);
        } catch (error) {
            log.error(`UserModal - validate failed: ${error}`);
        }
    };

    useEffect(() => {
        if (initialValues) {
            form.setFieldsValue(initialValues);
        }

        return () => {
            form.resetFields();
        };
    }, []);

    const resetFormField = (fieldNames) => {
        const fieldsToReset = {};

        fieldNames.forEach((name) => (fieldsToReset[name] = null));
        form.setFieldsValue(fieldsToReset);
    };

    const setFormField = (name, key, value) => form.setFieldsValue({[name]: {id: key, value}});

    const handleRadioChange = (value, name) => {
        form.setFieldsValue({[name]: value});
    };

    const handleSelect = async (value, name, option) => {
        const currentValue = form.getFieldValue(name);

        if (currentValue?.value === option.value) return;

        setFormField(name, option.key, option.value);

        switch (name) {
            case formInputNames.CITY: {
                resetFormField([formInputNames.ORGANIZATION, formInputNames.ALL_BUILDINGS]);

                await organizationsService.getOrganizationsNames(value);
                break;
            }
            case formInputNames.ORGANIZATION: {
                resetFormField([formInputNames.ALL_BUILDINGS]);

                break;
            }
            case formInputNames.REPORT_TYPE: {
                resetFormField([formInputNames.DEVICE_GROUP]);

                break;
            }
            default:
                break;
        }
    };

    const handleChange = () => {};

    if (isMobile) {
        return (
            <MobileModalForm
                form={form}
                formName='ars-buildings-settings'
                title={
                    <>
                        {title}
                        {selectedAddresses.length > 0 && (
                            <span className='mt-1 block text-12 font-normal leading-18 text-santa'>
                                {selectedAddresses.length === 1
                                    ? selectedAddresses[0]
                                    : strings.formatString(
                                          strings[localizationKeys.USERS_MOBILE_SELECTED],
                                          selectedAddresses.length
                                      )}
                            </span>
                        )}
                    </>
                }
                closeLabel={strings[localizationKeys.SERVICES_MOBILE_CLOSE]}
                onCancel={onCancel}
                formFields={formContent.map((field) => ({
                    ...field,
                    hidden:
                        typeof field.hidden === 'function'
                            ? (values) => field.hidden(undefined, values[field.itemDeps])
                            : field.hidden,
                }))}
                initialValues={initialValues}
                onFinish={onFinish}
                submitButton={submitButton}
                cancelButton={cancelButton}
                handleChange={handleChange}
                handleSelect={handleSelect}
                handleRadioChange={handleRadioChange}
                requireDeps={requireDeps}
            />
        );
    }

    return (
        <Form
            formClassName='ars-buildings-form'
            containerClassName='ars-buildings-form-content'
            buttonsClassName='ars-buildings-form-actions'
            handleRadioChange={handleRadioChange}
            handleSelect={handleSelect}
            closeModal={onCancel}
            initialValues={initialValues}
            submitButton={submitButton}
            onFinish={onFinish}
            title={title}
            formFields={formContent}
            cancelButton={cancelButton}
            formInstance={form}
            requireDeps={requireDeps}
            handleChange={handleChange}
        />
    );
};

export default React.memo(ArsBuildingsModal);
